import { render } from "./ChapterTutorial.vue?vue&type=template&id=7520aac7"
import script from "./ChapterTutorial.vue?vue&type=script&lang=js"
export * from "./ChapterTutorial.vue?vue&type=script&lang=js"

import exportComponent from "/builds/web-factory/barsmart/frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__